import React from 'react'
import ReactDOM from 'react-dom/client'
import '@fontsource/inter/latin-400.css'
import '@fontsource/inter/latin-500.css'
import '@fontsource/inter/latin-600.css'
import '@fontsource/inter/latin-700.css'
import '@fontsource/sora/latin-400.css'
import '@fontsource/sora/latin-500.css'
import '@fontsource/sora/latin-600.css'
import '@fontsource/sora/latin-700.css'
import { installTranslationDomGuard } from './lib/translationDomGuard'
import App from './App.tsx'
import './globals.css'
import './i18n'

// Make React resilient to DOM reparenting by browser translation tools
// (e.g. Chrome "Translate to English"). Must run before render.
installTranslationDomGuard()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
